export default {
  title: 'SEO',
  subtitle:
    'Customise the title and description that appear in Google search results and social previews. Leave empty to use the default values.',
  fields: {
    title: {
      label: 'Page title',
      placeholder: 'e.g. Forza Napoli — authentic Neapolitan pizza in Munich',
      help: 'Shown as the headline in Google results and on browser tabs. Up to 255 characters; aim for 50–60 for best preview.',
    },
    description: {
      label: 'Meta description',
      placeholder: 'Short summary of your restaurant that will appear under the title in search results.',
      help: 'Up to 500 characters; Google typically displays 150–160. Highlight what makes your restaurant unique.',
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    saved: 'SEO settings saved',
    failed: 'Failed to save SEO settings',
  },
};
